import axios, { AxiosHeaders } from 'axios';
import dayjs from 'dayjs';
import { Error } from '../types/axios';

const baseUrl = import.meta.env.VITE_APP_API_URL;

axios.defaults.withCredentials = true;

const instance = axios.create({
  baseURL: baseUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(
  (config) => {
    const sessionId = localStorage.getItem('session_id');
    if (sessionId) {
      const headers = AxiosHeaders.from(config.headers);
      headers.set('X-session-ID', sessionId);
      config.headers = headers;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  function (response) {
    const lifetime = localStorage.getItem('lifetime');
    if (lifetime) {
      const sessionLifetime = dayjs().add(parseInt(lifetime), 'seconds').unix();
      localStorage.setItem('session_lifetime', sessionLifetime.toString());
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default instance;

export const getErrorMessage = (error: Error) => {
  return Object.values(error.response.data.error)[0];
};
